import { isEqual } from "lodash-es";
export var Equality;
(function (Equality) {
    Equality[Equality["NOT_EQUAL"] = 0] = "NOT_EQUAL";
    Equality[Equality["EQUAL"] = 1] = "EQUAL";
    Equality[Equality["NO_COMPARISON"] = -1] = "NO_COMPARISON";
})(Equality || (Equality = {}));
export const Identical = Symbol("Identical");
export const NoComparison = Symbol("NoComparison");
/**
 * Runs a targetFunction and immediately resolves assuming success
 * Provides methods for handling failure or different eventual success
 */
export class AsyncOptimist {
    constructor({ assume, onFailure, onSuccess }) {
        this.assume = assume;
        this.onFailure = onFailure;
        this.onSuccess = onSuccess;
    }
    /**
     * Returns a comparison between the actual result and assumed result
     * @param result
     * @param assumedResult
     * @returns
     */
    didChange(result, assumedResult) {
        try {
            if (isEqual(result, assumedResult)) {
                return Equality.EQUAL;
            }
            else {
                return Equality.NOT_EQUAL;
            }
        }
        catch (err) {
            console.log("Actual", result);
            console.log("Assumed", assumedResult);
            console.warn(`Unable to compare actual result and assumed result: ${err.message}`);
            console.error(err);
            return Equality.NO_COMPARISON;
        }
    }
    run(target, input) {
        return new Promise((resolve, reject) => {
            try {
                let assumption = this.assume(input);
                resolve(assumption);
                target(input)
                    .then(result => {
                    let comparison = this.didChange(result, assumption);
                    this.onSuccess(input, result, assumption, comparison);
                })
                    .catch(err => {
                    this.onFailure(err);
                });
            }
            catch (err) {
                console.warn(`Unable to run target function [${target.name}]: ${err.message}`);
                reject(err);
            }
        });
    }
}
export function optimist(input, optionsOrTargetFunction, options) {
    let targetFunction;
    if (!options) {
        options = optionsOrTargetFunction;
    }
    else {
        targetFunction = optionsOrTargetFunction;
    }
    let _optimist = new AsyncOptimist(options);
    if (targetFunction) {
        // If the asyncFunction was provided
        return _optimist.run(targetFunction, input);
    }
    else {
        return _optimist;
    }
}
//# sourceMappingURL=optimist.js.map